/**
 * Determine whether a URL contains known pre-signed query parameters.
 *
 * @param url URL to inspect.
 * @returns True when the URL contains a recognized signature parameter.
 */
export default function isPresignedUrl(url?: string): boolean {
	if (
		!url
		|| typeof url !== 'string'
	) {
		return false;
	}

	try {
		const parsedUrl = new URL(
			url,
			'https://creator.local',
		);

		return (
			parsedUrl.searchParams.has('X-Amz-Signature')
			|| parsedUrl.searchParams.has('X-Amz-Credential')
			|| parsedUrl.searchParams.has('AWSAccessKeyId')
			|| parsedUrl.searchParams.has('Signature')
		);
	} catch {
		return false;
	}
}
